
import {Component, Vue} from "vue-property-decorator";
import {Getter} from "vuex-class";
import { mdiAccountCog, mdiAccountKey, mdiDoorOpen, mdiGroup, mdiKey, mdiNoteText } from "@mdi/js";
import KeyGroupEdit from "@/components/key-groups/KeyGroupEdit.vue";
import EditBtn from "@/components/generic/buttons/edit-btn.vue";
import DeleteBtn from "@/components/generic/buttons/delete-btn.vue";
import SvgIcon from "@jamescoyle/vue-icon";

const septeoImage = require("@/assets/images/septeo.png");

@Component({
    components: {
        DeleteBtn,
        EditBtn,
        KeyGroupEdit,
        SvgIcon,
    },
})
export default class KeyGroupPage extends Vue {

    get canSeeMissionOrders(): boolean {
      return this.hasRight("MANAGE_MISSION_ORDERS");
    }

    get canSeeManagers(): boolean {
        return this.hasRight("VIEW_KEY_MANAGERS");
    }

    get canSeeGuests(): boolean {
        return this.hasRight("VIEW_KEY_GUESTS");
    }

    get canSeeNonTransferables(): boolean {
        return this.hasRight("MANAGE_NON_TRANSFERABLES");
    }

    @Getter private currentUser: any;
    @Getter private canDoInEnvCompany: (right: string) => boolean;
    @Getter private isMobile: boolean;

    private septeoImage = septeoImage;

    private keyGroupId = null;
    private keyGroup: any = null;
    private editGroup: any = null;
    private loadingDeleteKeyGroup: boolean = false;
    private subTab: string = null;
    private loadingSubTab: boolean = false;
    private isManager: boolean = false;

    private icons = {
      mdiDoorOpen,
      mdiKey,
      mdiNoteText,
      mdiAccountCog,
      mdiAccountKey,
      mdiGroup,
    };

    get canDeleteGroup(): boolean {
      return !this.keyGroup.septeoListingId;
    }

    private mounted(): void {
        this.keyGroupId = Number(this.$route.params.id);
        this.reset();
    }

    private closeEditKeyGroups(): void {
        this.editGroup = null;
    }

    private openEditKeyGroup(): void {
        this.editGroup = { ...this.keyGroup };
    }

    private hasRight(right: string): boolean {
        return this.canDoInEnvCompany(right);
    }

    private reset() {
      this.getKeyGroupById();
      this.setIsManager();
    }

    private async getKeyGroupById(): Promise<void> {
      await this.$store.dispatch("keyGroups/getById", {
          id: this.keyGroupId,
      }).then((res) => {
          this.keyGroup = res;
      }).catch((error) => {
          this.$store.commit("alerts/displayHttpError", { error });
      });
    }

    private async setIsManager(): Promise<void> {
      await this.$store.dispatch("keyManagements/getByEntities", {
        keyGroupId: this.keyGroupId,
        userId: this.currentUser.id,
      }).then((data) => {
        this.isManager = !!data?.length;
      }).catch((err) => {
        this.isManager = false;
      });
    }

    private async deleteKeyGroup(): Promise<void> {
      this.loadingDeleteKeyGroup = true;
      if (confirm(String(this.$t("keyGroup.deleteConfirmation")))) {
            await this.$store.dispatch("keyGroups/deleteById", {
              id: this.keyGroup.id,
            }).then(async (res) => {
              await this.$router.push({name: "keys", params : { tab : "groups"}});
            }).catch((error) => {
              this.$store.commit("alerts/displayHttpError", { error });
            }).finally(() => {
              this.loadingDeleteKeyGroup = false;
            });
        }
    }

}
